module.exports = __webpack_public_path__ + "static/gallery_west_street_4-4c1bbe7d06e30c6514e7be84b608b8b0.jpg";